import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle, MessageCircle } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qtRkR6UFYwHcZHUZTWVph1/Titulo.png';
const WHATSAPP_LINK = 'https://wa.me/50689925929?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20certificaci%C3%B3n%20de%20GAS%20LP%20para%20mi%20establecimiento';
export function Hero() {
  return <section className="relative bg-[#1e3a5f] text-white overflow-hidden pt-24 lg:pt-20" data-id="element-132">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-133" />

      {/* Large Background Logo */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-134">
        <img src={LOGO_URL} alt="" className="w-[800px] h-auto opacity-[0.08] brightness-0 invert" data-id="element-135" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32 flex flex-col lg:flex-row items-center" data-id="element-136">
        <div className="w-full lg:w-1/2 text-center lg:text-left z-10" data-id="element-137">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-138">
            {/* Logo Badge */}
            <div className="inline-flex items-center gap-3 px-4 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-sm mb-6" data-id="element-139">
              <img src={LOGO_URL} alt="Jazugas" className="h-10 w-auto brightness-0 invert" data-id="element-140" />
              <span className="text-blue-200 text-sm font-medium" data-id="element-141">
                Solución Oficial para Costa Rica
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-142">
              Certifica tu Gas LP en{' '}
              <span className="text-[#f59e0b]" data-id="element-143">48 Horas</span> sin Trámites
              Infinitos
            </h1>
            <p className="text-lg md:text-xl text-blue-100 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-144">
              La plataforma digital que elimina la burocracia y te guía paso a
              paso hasta obtener tu certificación del Ministerio de Salud.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-145">
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-[#f59e0b] hover:bg-[#d97706] text-white font-bold rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-lg" data-id="element-146">
                Comenzar Certificación Ahora
                <ArrowRight className="w-5 h-5" data-id="element-147" />
              </a>
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-lg backdrop-blur-sm transition-all flex items-center justify-center gap-2" data-id="element-148">
                <MessageCircle className="w-5 h-5" data-id="element-149" />
                ¿Dudas? Escríbenos
              </a>
            </div>

            <div className="mt-8 flex items-center justify-center lg:justify-start gap-2 text-sm text-blue-200" data-id="element-150">
              <CheckCircle className="w-4 h-4 text-[#f59e0b]" data-id="element-151" />
              <span data-id="element-152">+500 negocios certificados exitosamente</span>
            </div>
          </motion.div>
        </div>

        <div className="w-full lg:w-1/2 mt-12 lg:mt-0 relative z-10" data-id="element-153">
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="relative" data-id="element-154">
            {/* Certificate Card with Logo */}
            <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 max-w-md mx-auto transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-155">
              {/* Logo watermark */}
              <div className="absolute top-4 right-4 opacity-20" data-id="element-156">
                <img src={LOGO_URL} alt="" className="h-16 w-auto" data-id="element-157" />
              </div>

              <div className="flex items-center gap-4 mb-6 border-b border-gray-100 pb-4" data-id="element-158">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-159">
                  <CheckCircle className="w-6 h-6 text-green-600" data-id="element-160" />
                </div>
                <div data-id="element-161">
                  <h3 className="text-gray-900 font-bold text-lg" data-id="element-162">
                    Certificado Aprobado
                  </h3>
                  <p className="text-gray-500 text-sm" data-id="element-163">Ministerio de Salud</p>
                </div>
              </div>
              <div className="space-y-3" data-id="element-164">
                <div className="h-2 bg-gray-100 rounded w-3/4" data-id="element-165"></div>
                <div className="h-2 bg-gray-100 rounded w-1/2" data-id="element-166"></div>
                <div className="h-2 bg-gray-100 rounded w-full" data-id="element-167"></div>
                <div className="h-2 bg-gray-100 rounded w-5/6" data-id="element-168"></div>
              </div>
              <div className="mt-6 pt-4 border-t border-gray-100 flex justify-between items-center" data-id="element-169">
                <span className="text-xs text-gray-400" data-id="element-170">Estado:</span>
                <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-bold rounded-full" data-id="element-171">
                  VIGENTE
                </span>
              </div>
            </div>

            {/* Floating elements */}
            <div className="absolute -top-6 -right-6 bg-[#f59e0b] p-4 rounded-lg shadow-lg hidden md:block animate-bounce" data-id="element-172">
              <span className="font-bold text-white" data-id="element-173">¡Rápido! ⚡</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}